import { useEffect, useState } from "react";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { cachedGet, fileUrl } from "@/lib/api";

function initials(name) {
  return name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();
}

export default function Members() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    cachedGet("/members").then(({ data }) => setMembers(data)).catch(() => {});
  }, []);

  if (!members.length) return null;

  return (
    <section className="px-6 md:px-12 py-24 md:py-32 bg-surface/50" data-testid="ensemble-section">
      <SectionHeading overline="The Ensemble" title="One band," italic="ten hearts" testid="ensemble-heading" />
      <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-bone/10 border border-bone/10">
        {members.map((m, i) => (
          <Reveal key={m.id} delay={Math.min(i * 0.05, 0.4)} y={24}>
            <div className="group bg-ink h-full" data-testid={`ensemble-card-${i}`}>
              <div className="aspect-square overflow-hidden relative">
                {m.image_url ? (
                  <img src={fileUrl(m.image_url)} alt={m.name} loading="lazy"
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-surface">
                    <span className="font-serif text-5xl text-saffron/60 group-hover:text-saffron transition-colors">{initials(m.name)}</span>
                  </div>
                )}
                <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-ink/90 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-4">
                  <p className="font-serif text-lg text-bone leading-tight">{m.name}</p>
                  <p className="text-[10px] font-display tracking-[0.2em] uppercase text-saffron mt-1">{m.role}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
